var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('vue-splash',{attrs:{"show":true,"logo":_vm.logo,"color":"#00a0ff","size":300,"fixed":true}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }